module.exports = __webpack_public_path__ + "media/28.eee8bcb9.wav";